import { useEffect, useState } from "react";
function useSticky(ref) {
  var _useState = useState(false),
    isSticky = _useState[0],
    setIsSticky = _useState[1];
  useEffect(function () {
    var element = ref.current;
    if (!element) {
      console.error("The ref provided to useSticky is not attached to any element.");
      return;
    }
    var handleScroll = function handleScroll() {
      var computedStyle = window.getComputedStyle(element);
      if (computedStyle.position !== "sticky") {
        setIsSticky(false);
        return;
      }
      var rect = element.getBoundingClientRect();
      var stickyTop = parseInt(computedStyle.top || "0", 10);
      var stickyBottom = parseInt(computedStyle.bottom || "0", 10);
      var isCurrentlySticky = false;

      // ✅ Backwards compatibility: top stickiness
      if (!isNaN(stickyTop) && stickyTop >= 0) {
        isCurrentlySticky = rect.top === stickyTop;
      }

      // ✅ New: bottom stickiness
      if (!isNaN(stickyBottom) && stickyBottom >= 0) {
        var viewportHeight = window.innerHeight;
        if (rect.bottom === viewportHeight - stickyBottom) {
          isCurrentlySticky = true;
        }
      }
      setIsSticky(isCurrentlySticky);
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll(); // initial check

    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [ref]);
  return isSticky;
}
export default useSticky;